module.exports = __webpack_public_path__ + "img/Esperion_logo@2x.1d72be39.png";